import Vue from 'vue'
import { mcSetTitle } from '@/utils/mcSdkUtils'
import Main from './main.vue'

const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数

let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const GuardianBook = options => {
  return new Promise((resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      title: options.title || '',
      memberCount: options.memberCount || '',
      campusId: options.campusId || '',
      sandboxId: options.sandboxId || '',
      sandboxType: options.sandboxType || 4, // 沙盒类型
      groupId: options.groupId || '',
      // 0: 人员 1: 部门 2: 人员tpId 3: 部门tpId 4: 人员memberId 5: 部门memberId 6: 全选  *选人不建议使用部门*
      returnType: options.returnType || 0,
      multiple: options.multiple || false, // 是否多选
      maxMember: options.multiple ? options.maxMember || 1500 : 1, // 最大可选人员
      forceSelection: options.forceSelection || false, // 强制重新勾选已选（兼容）
      needReturn:
        typeof options.needReturn === 'boolean' ? options.needReturn : true, // 直接退出是否需要返回
      removeDelay: options.removeDelay || 100, // 是否延时去除dom
      isSandboxComplete: options.isSandboxComplete,
      selectedMemberIds: options.selectedMemberIds || [], // 已选择memberId，与selectedTpIds互斥
      selectedDeptIds: options.selectedDeptIds || [], // 已选择deptId，与selectedDeptTpIds互斥
      selectedTpIds: options.selectedTpIds || [], // 已选择tpId，与selectedMemberIds互斥
      selectedDeptTpIds: options.selectedDeptTpIds || [] // 已选择部门tpId，与selectedDeptIds互斥
    }
    // eslint-disable-next-line space-before-function-paren
    _options.close = function (result) {
      GuardianBook.close()
        .then(res => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line space-before-function-paren
    _options.closeOnly = function () {
      GuardianBook.close()
        .then(res => {
          resolve({
            $type: this.needReturn ? 'onlyReturn' : ''
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({ data: _options })

    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    _options.title && mcSetTitle(_options.title)
    if (!_options.appendNode) {
      document.body.appendChild(MInstance.dom) // 将dom插入body
    } else {
      document.getElementById('app').appendChild(MInstance.dom)
    }

    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
GuardianBook.close = function (params) {
  return new Promise((resolve, reject) => {
    // //销毁vm实例与DOM之间的关联
    MInstance.vm.$destroy()
    window.history.go(-1)
    // 防止返回后通讯录一直盖在界面上没有消失
    let $addressDom = MInstance.dom
    $addressDom && $addressDom.remove()
    MInstance = null
    resolve()
  })
}

export default GuardianBook
